import React, { useEffect } from "react";
import { Stakeholder } from "../../Objects/Project";
import DynamicTable from "../tables/DynamicTable";
import DialogForm from "./Dialog";

import { Alert, Box, CircularProgress, Typography } from "@mui/joy";
import { ApiService } from "../../api/ProjectInfoService";
import { ToastContainer, toast } from "react-toastify";
import { Toast } from "@fluentui/react-components";

interface ILedenProps {
  data: Stakeholder[];
  title: string;
  email: string;
  dospId: string;
  userIsPrivileged: boolean;
}
function LedenBox({ data, title, email, dospId , userIsPrivileged }: ILedenProps) {
  const [contactpersons, setContactpersons] = React.useState<any[]>([]);
  const [accountTypes, setAccountTypes] = React.useState<any[]>([]);
  const [accounts, setAccounts] = React.useState<any[]>([]);
  const [memberTypes, setMemberTypes] = React.useState<any[]>([]);
  const [roleTypes, setRoleTypes] = React.useState<any[]>([]);

  useEffect(() => {
      if (userIsPrivileged) {
        ApiService.getContactData().then((res) => {
          return setContactpersons(res.data.models);
        }).catch((error) => {
          toast.error("Er is iets misgegaan met het ophalen van de Contact data");
        });
        ApiService.getAccountsData().then((res) => {
          return setAccounts(res.data.models);
        }).catch((error) => {
          toast.error("Er is iets misgegaan met het ophalen van de Account data");
        });
        ApiService.getAccountTypesOnly().then((res) => {
          return setAccountTypes(res.data);
        }).catch((error) => {
          toast.error("Er is iets misgegaan met het ophalen van de Account types");
        });
        ApiService.getMemberTypes().then((res) => {
          return setMemberTypes(res.data);
        }).catch((error) => {
          toast.error("Er is iets misgegaan met het ophalen van de Member types");
        }); 
        ApiService.getRoleTypes().then((res) => {
          return setRoleTypes(res.data);
        }).catch((error) => {
          toast.error("Er is iets misgegaan met het ophalen van de Role types");
        });
      }


  }, []);
  
  const onSave = (data: any) => {
    const dataToSend = {
      relation: data.memberType?.id,
      knowledgeGroup: data.knowledgeGroup?.id,
      contactId: {
        id: data.contact?.id,
        firstname: data.firstname ? data.firstname : null,
        lastname: data.lastname? data.lastname : null,
        email: data.email? data.email : null,
        language: null,
        account: {
          id: data.contact?.account.id ? data.contact?.account.id : data.account?.id,
          tradename: data.tradename,
          officialname: data.officialname,
          vatnumber: data.vatnumber,
          type: data.accountType?.optionValue,
          subtype: data.subtype,
        }
      },
      startDate: data.startDate ? data.startDate : null,
      endDate: data.endDate ? data.endDate : null,
      role: data.roleType ? data.roleType.code : null,
      projectDospId: dospId
    };
    ApiService.postStakeholder(dataToSend).then((res) => {
      toast.success("Aanvraag is verstuurd");
    });
  }

 // if (contactpersons.length === 0 || accounts.length === 0 || accountTypes.length === 0 || memberTypes.length === 0 ) {
 //   return (
 //     //loading spinner icon
 //     <>
 //     <div className="loadingCircle">
 //       <CircularProgress
 //         size="lg"
 //         sx={{ "--CircularProgress-trackColor": "#484494", '--CircularProgress-progressColor': '#b6b4d4' }}
 //       />
 //     </div>
 //     <ToastContainer />
 //     </>
 //   );
 // }

  return (
    <>
    <div className="box">
      <div className="headerLeden">
        <h2>{title}</h2>
        {userIsPrivileged && <DialogForm onSave={onSave} memberTypes={memberTypes} contactpersons={contactpersons}  accountTypes={accountTypes.filter(a => a.isActive)} accounts={accounts.filter(a=> a.isActive)} roleTypes={roleTypes}/>}
      </div>
      <DynamicTable
        data={data}
        columns={[
          { id: 1, label: "Contact", property: "contactId.name" },
          { id: 2, label: "Start Datum", property: "startDate" },
          { id: 3, label: "Eind Datum", property: "endDate" },
          { id: 4, label: "Beschrijving", property: "description" },
          { id: 5, label: "Rol", property: "role" },
          { id: 9, label: "Type", property: "relation.name" },
          { id: 6, label: "Knowledge Group", property: "knowledgeGroup.name" },
          { id: 8, label: "ID", property: "id" },
          { id: 8, label: "Samenwerking teams", property: "includeInMsTeam" },
        ]}
        deletable={userIsPrivileged}
        editable={userIsPrivileged}
        onSave={onSave}
      />
    </div>
    <ToastContainer />
    </>
  );
}

export default LedenBox;
